<template>
  <brazil-field
    :input-id="inputId"
    :name="name"
    :label="label"
    :validator-field="validatorField"
    :validator-key="validatorKey"
  >
    <masked-input
      :id="inputId"
      v-model="model"
      :mask="mask"
      :guide="false"
      :type="type"
      :name="name"
      :value="value"
      :placeholder="placeholder"
      :class="status"
      :autocomplete="autocomplete"
      :padding-length="paddingLength"
      :padding-char="paddingChar"
      :maxlength="maxlength"
      :disabled="disabled"
      @blur="blur"
    />
    <template v-slot:note>
      <slot name="note" />
    </template>
  </brazil-field>
</template>
<script>
import MaskedInput, { conformToMask } from 'vue-text-mask';
import safeGet from '../../store/pathifyUtilities';
import BrazilField from './BrazilField.vue';

export default {
  components: {
    BrazilField,
    MaskedInput,
  },
  props: {
    name: {
      type:     String,
      required: true,
    },
    inputId: {
      type:     String,
      required: true,
    },
    type: {
      type:    String,
      default: 'text',
    },
    label: {
      type:     String,
      required: true,
    },
    autocomplete: {
      type:    String,
      default: null,
    },
    paddingLength: {
      type:    Number,
      default: 0,
    },
    paddingChar: {
      type:    String,
      default: null,
    },
    maxlength: {
      type:    [String, Number],
      default: null,
    },
    placeholder: {
      type:    String,
      default: null,
    },
    mask: {
      type:    [Array, Function, Boolean, Object],
      default: false,
    },
    /* eslint-disable-next-line vue/require-prop-types */
    value: {
      // string, number, or null
      validator: (prop) => typeof prop === 'string'
        || typeof prop === 'number'
        || prop === null
        || prop === undefined,
      required: true,
    },
    validatorField: {
      type:     Object,
      required: true,
    },
    validatorKey: {
      type:    String,
      default: null,
    },
  },
  data() {
    return {
      cachedStatus: null,
      cachedValue:  null,
      conformed:    false,
    };
  },
  computed: {
    backendErrors: safeGet('backendErrors', []),
    model:         {
      get() {
        const stringValue = (this.value && this.value.toString()) || '';

        if (!this.conformed) {
          const conformedValue = this.conformAgainstMap(stringValue || '');
          this.$emit('input', conformedValue);

          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.conformed = true;
          return conformedValue;
        }

        return stringValue;
      },
      set(value) {
        if (value !== this.cachedValue) {
          this.cachedValue = value;
          this.$emit('input', value);
        }
      },
    },
    status() {
      if (!this.validatorField.$pending || this.cachedStatus == null) {
        const errorForField = this.backendErrors ? this.backendErrors[this.name] : false;
        /* eslint-disable-next-line vue/no-side-effects-in-computed-properties */
        this.cachedStatus = {
          valid: this.validatorField.$dirty && !this.validatorField.$error,
          error: this.validatorField.$error || errorForField,
        };
      }

      return this.cachedStatus;
    },
    disabledFields: safeGet('registration/disabledFieldNames', []),
    disabled() {
      return this.disabledFields.includes(this.name);
    },
  },
  methods: {
    conformAgainstMap(input) {
      let conformedValue = input;
      if (this.mask) {
        conformedValue = conformToMask(
          input || '',
          this.mask,
          { guide: false },
        ).conformedValue.trim();
      }
      return conformedValue;
    },
    blur() {
      const stringValue = (this.value && this.value.toString()) || '';

      if (this.paddingChar && stringValue !== '') {
        let unmasked = stringValue;
        if (this.mask) {
          unmasked = unmasked.replace('-', '');
        }
        const padded = unmasked.padStart(this.paddingLength || this.maxlength, this.paddingChar);
        const conformed = this.conformAgainstMap(padded);
        this.$emit('input', conformed);
      }

      if (this.$store !== undefined) {
        this.$store.dispatch('setBackendErrors', null);
        this.$store.dispatch('setBackendErrorMessages', null);
      }

      this.validatorField.$touch();
    },
  },
};
</script>
<style lang="scss" scoped>
  input.error {
    border: 1px solid #d0021b;
  }
</style>
